module.exports = __webpack_public_path__ + "img/photo.292f7ed7.png";